// extracted by mini-css-extract-plugin
module.exports = {"navIcon":"style_navIcon__ULHTW","active":"style_active__WfUxA","icon":"style_icon__rlgx5"};